import { TYPES_TESTIMONIAL } from '@/redux/testimonial/testimonial.types';
import { SERVICE_TESTIMONIAL } from '@/services/testimonial.service';

const getTestimonialData = () => {
  return (dispatch) => {
    dispatch({ type: TYPES_TESTIMONIAL.GET_TESTIMONIAL_DATA_LOADING, loading: true });

    SERVICE_TESTIMONIAL.getTestimonialData((res) => {
      dispatch({ type: TYPES_TESTIMONIAL.GET_TESTIMONIAL_DATA_LOADING, loading: false });

      dispatch({
        type: TYPES_TESTIMONIAL.GET_TESTIMONIAL_LIST,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

export const ACTION_TESTIMONIAL = { getTestimonialData };
